import React from 'react'
import PropTypes from 'prop-types'
import ImageCropper from '../../atoms/ImageCropper/ImageCropper'

type ImageCropperPostmanProps = {
    title: string
    description: string
    avatar?: string
    icon?: string
    company?: { name: string }
    role?: string
    initialImage?: string
    fullName?: string
}

const ImageCropperPostman: React.FC<ImageCropperPostmanProps> = ({
    title,
    description,
    avatar,
    company,
    fullName,
}) => {
    return (
        <div className="py-4 flex items-center bg-white relative">
            <ImageCropper avatar={avatar} fullName={fullName} />
            <div className="ml-4 mt-8">
                {company && (
                    <>
                        <span className="absolute top-4 bg-gray-100 text-xs text-gray-500 px-2 py-0.5 rounded-full border border-gray-300">
                            {company.name}
                        </span>
                    </>
                )}

                <h2 className="text-2xl font-medium text-gray-800">{title}</h2>
                <p className="text-lg text-black-600 flex items-center mt-1">
                    {description}
                </p>
            </div>
        </div>
    )
}

ImageCropperPostman.propTypes = {
    onImageUpload: PropTypes.func,
    title: PropTypes.string,
    description: PropTypes.string,
    avatar: PropTypes.string,
    icon: PropTypes.string,
}

export default ImageCropperPostman
